export default "<custom-list [dataSource]='receiveSource' [displayedColumns]='displayedColumns'></custom-list>"